import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import BlogPost from '../components/blog-post'
import Footer from '../components/footer'
import IntegrationsNav from '../components/integrations-nav'
import { client, blogQueries } from '../sanityClient'
import './blog-post-view.css'

const BlogPostView = () => {
  const { slug } = useParams()
  const [post, setPost] = useState(null)
  const [loading, setLoading] = useState(true)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const fetchPost = async () => {
      try {
        setLoading(true)
        const fetchedPost = await client.fetch(blogQueries.getPostBySlug, { slug })
        setPost(fetchedPost)
      } catch (err) {
        console.error('Error fetching blog post for SEO:', err)
        setPost(null)
      } finally {
        setLoading(false)
      }
    }
    if (slug) fetchPost()
  }, [slug])

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className="blog-post-view-container">
      <nav className={`bpv-nav${scrolled ? ' bpv-nav--scrolled' : ''}`}>
        <div className="bpv-nav-inner">
          <Link to="/" className="bpv-nav-logo">
            <img src="/dataflows-high-resolution-logo-200h.png" alt="DataFlows" height="34" />
          </Link>
          <div className="bpv-nav-links">
            <a href="/#features">Features</a>
            <a href="/#pricing">Pricing</a>
            <Link to="/blog">Blog</Link>
            <IntegrationsNav />
            <Link to="/contact-us">Contact Us</Link>
          </div>
          <div className="bpv-nav-actions">
            <a href="https://sms.dataflows.com.au" target="_blank" rel="noreferrer noopener" className="bpv-sign-in">Sign in</a>
            <a href="https://sms.dataflows.com.au/register" target="_blank" rel="noreferrer noopener" className="bpv-get-started">Get started</a>
          </div>
        </div>
      </nav>

      <main className="blog-post-view-main">
        <BlogPost />
      </main>

      <Footer />
    </div>
  )
}

export default BlogPostView
